import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index'
import dataBig from '@/view/data_big'

Vue.use(Router)

export default new Router({
    routes: [{
        path: '/',
        name: 'index',
        component: index
    },{
      path: '/dataBig',
      name: 'data_big',
      component: dataBig
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js